import { useEffect } from "react";

export default function SEO({ title, description, canonical }) {
  useEffect(() => {
    if (title) document.title = title + " | CochlearImplantSurgery.in";
    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    if (description) setMeta("description", description);
    if (canonical) {
      let l = document.querySelector('link[rel="canonical"]');
      if (!l) {
        l = document.createElement("link");
        l.setAttribute("rel", "canonical");
        document.head.appendChild(l);
      }
      l.setAttribute("href", canonical);
    }
  }, [title, description, canonical]);
  return null;
}
